<template>
    <transition name="fade">
        <div class="top-0 left-0 w-full p-4 lg:p-0" :class="classes" v-if="show">
            <slot :closePopup="closePopup"></slot>
        </div>
    </transition>
</template>

<script>
    import {eventBus} from '../eventBus';

    export default {
        name: "PopOpenBox",

        props: {
            name: String,
            screenHeight: {
                type: Boolean,
                default: false
            },
            bgClass: {
                type: String,
                default: null
            },
            defaultShow: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            classes() {
                return [
                    !this.screenHeight ? 'min-h-full' : 'min-h-screen',
                    this.bgClass === null ? 'bg-white' : this.bgClass,
                    this.defaultShow ? 'absolute' : 'fixed z-50'
                ]
            }
        },
        data() {
            return {
                show: this.defaultShow
            }
        },

        created() {
            eventBus.$on('openPopup', (openIndex) => {
                this.show = openIndex === this.name;
            });
            eventBus.$on('closePopup', (closeIndex) => {
                if (closeIndex === this.name) {
                    this.show = false;
                }
            })
        },

        methods: {
            closePopup() {
                this.show = false;
                this.$emit('close-popup');
            },
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .02s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>